import React, { Component } from 'react';
import './ClearButton.css';

export default class ClearButton extends Component {

  render(){
    return (
      <div onClick={this.props.onClick} className={`clear-button-wrap ${this.props.active ? 'active' : ''}`}>{this.props.text || 'Lorem ipsum'}</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/ClearButton.js